module.exports = __webpack_public_path__ + "img/page-25.410384ad.jpg";